import { render, staticRenderFns } from "./Select-client-Pic-address.vue?vue&type=template&id=85489d48&scoped=true"
import script from "./Select-client-Pic-address.vue?vue&type=script&lang=js"
export * from "./Select-client-Pic-address.vue?vue&type=script&lang=js"
import style0 from "./Select-client-Pic-address.vue?vue&type=style&index=0&id=85489d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85489d48",
  null
  
)

export default component.exports